import { getUserConfig } from '../useUserConfig.ts'
import { translateCountriesLabel } from '../utils.ts'

export type Country = {
  label: () => string
  code: string
  flag: string
  prefix: number
}

export const CURRENCIES_COUNTRY: Record<string, string> = {
  AF: 'USD',
  AX: 'EUR',
  AL: 'USD',
  DZ: 'USD',
  AS: 'USD',
  AD: 'EUR',
  AO: 'USD',
  AI: 'USD',
  AQ: 'USD',
  AG: 'USD',
  AR: 'USD',
  AM: 'USD',
  AW: 'USD',
  AU: 'AUD',
  AT: 'EUR',
  AZ: 'USD',
  BS: 'USD',
  BH: 'USD',
  BD: 'USD',
  BB: 'USD',
  BY: 'USD',
  BE: 'EUR',
  BZ: 'USD',
  BJ: 'USD',
  BM: 'USD',
  BT: 'USD',
  BO: 'USD',
  BA: 'USD',
  BW: 'USD',
  BV: 'NOK',
  BR: 'USD',
  IO: 'USD',
  BG: 'USD',
  BF: 'USD',
  BI: 'USD',
  KH: 'USD',
  CM: 'USD',
  CA: 'CAD',
  CV: 'USD',
  KY: 'USD',
  CF: 'USD',
  TD: 'USD',
  CL: 'USD',
  CN: 'USD',
  CX: 'AUD',
  CC: 'AUD',
  CO: 'USD',
  KM: 'USD',
  CG: 'USD',
  CD: 'USD',
  CK: 'NZD',
  CR: 'USD',
  CI: 'USD',
  HR: 'USD',
  CU: 'USD',
  CY: 'EUR',
  DK: 'DKK',
  DJ: 'USD',
  DM: 'USD',
  DO: 'USD',
  EC: 'USD',
  EG: 'USD',
  SV: 'USD',
  GQ: 'USD',
  ER: 'USD',
  EE: 'EUR',
  ET: 'USD',
  FK: 'GBP',
  FO: 'DKK',
  FJ: 'USD',
  FI: 'EUR',
  FR: 'EUR',
  GF: 'EUR',
  PF: 'USD',
  TF: 'EUR',
  GA: 'USD',
  GM: 'USD',
  GE: 'USD',
  DE: 'EUR',
  GH: 'USD',
  GI: 'GBP',
  GR: 'EUR',
  GL: 'DKK',
  GD: 'USD',
  GP: 'EUR',
  GU: 'USD',
  GT: 'USD',
  GG: 'GBP',
  GN: 'USD',
  GW: 'USD',
  GY: 'USD',
  HT: 'USD',
  HM: 'AUD',
  VA: 'EUR',
  HN: 'USD',
  IS: 'USD',
  IN: 'USD',
  ID: 'USD',
  IR: 'USD',
  IQ: 'USD',
  IE: 'EUR',
  IM: 'GBP',
  IT: 'EUR',
  JM: 'USD',
  JE: 'GBP',
  JO: 'USD',
  KZ: 'USD',
  KE: 'USD',
  KI: 'AUD',
  KP: 'USD',
  KR: 'USD',
  KW: 'USD',
  KG: 'USD',
  LA: 'USD',
  LV: 'USD',
  LB: 'USD',
  LS: 'USD',
  LR: 'USD',
  LY: 'USD',
  LI: 'CHF',
  LT: 'USD',
  LU: 'EUR',
  MO: 'USD',
  MK: 'USD',
  MG: 'USD',
  MW: 'USD',
  MV: 'USD',
  ML: 'USD',
  MT: 'EUR',
  MH: 'USD',
  MQ: 'EUR',
  MR: 'USD',
  MU: 'USD',
  YT: 'EUR',
  FM: 'USD',
  MD: 'USD',
  MC: 'EUR',
  MN: 'USD',
  ME: 'EUR',
  MS: 'USD',
  MA: 'USD',
  MZ: 'USD',
  MM: 'USD',
  NA: 'USD',
  NR: 'AUD',
  NP: 'USD',
  NL: 'EUR',
  AN: 'USD',
  NC: 'USD',
  NZ: 'NZD',
  NI: 'USD',
  NE: 'USD',
  NG: 'USD',
  NU: 'NZD',
  NF: 'AUD',
  MP: 'USD',
  NO: 'NOK',
  OM: 'USD',
  PK: 'USD',
  PW: 'USD',
  PA: 'USD',
  PG: 'USD',
  PY: 'USD',
  PE: 'USD',
  PN: 'NZD',
  PT: 'EUR',
  PR: 'USD',
  QA: 'USD',
  RE: 'EUR',
  RO: 'USD',
  RU: 'USD',
  RW: 'USD',
  BL: 'EUR',
  SH: 'GBP',
  KN: 'USD',
  LC: 'USD',
  MF: 'EUR',
  PM: 'EUR',
  VC: 'USD',
  WS: 'USD',
  SM: 'EUR',
  ST: 'USD',
  SA: 'USD',
  SN: 'USD',
  RS: 'USD',
  SC: 'USD',
  SL: 'USD',
  SK: 'EUR',
  SI: 'EUR',
  SB: 'USD',
  SO: 'USD',
  ZA: 'USD',
  GS: 'GBP',
  ES: 'EUR',
  LK: 'USD',
  SD: 'USD',
  SR: 'USD',
  SJ: 'NOK',
  SZ: 'USD',
  SE: 'SEK',
  CH: 'CHF',
  SY: 'USD',
  TJ: 'USD',
  TZ: 'USD',
  TL: 'USD',
  TG: 'USD',
  TO: 'USD',
  TT: 'USD',
  TN: 'USD',
  TR: 'USD',
  TM: 'USD',
  TC: 'USD',
  TV: 'AUD',
  UG: 'USD',
  UA: 'USD',
  AE: 'USD',
  GB: 'GBP',
  US: 'USD',
  UM: 'USD',
  UY: 'USD',
  UZ: 'USD',
  VU: 'USD',
  VE: 'USD',
  VN: 'USD',
  VG: 'USD',
  VI: 'USD',
  WF: 'USD',
  EH: 'USD',
  YE: 'USD',
  ZM: 'USD',
  ZW: 'USD',
}

type SupportedCountries = {
  [currencyCode: string]: {
    [countryCode: string]: () => string
  }
}

function getLabel(code: string) {
  const userConfig = getUserConfig()
  return translateCountriesLabel(code, userConfig.lang)
}

export const SUPPORTED_COUNTRIES: SupportedCountries = {
  EUR: {
    AD: () => {
      return getLabel('AD') ?? 'Andorre'
    },
    AT: () => {
      return getLabel('AT') ?? 'Autriche'
    },
    BE: () => {
      return getLabel('BE') ?? 'Belgique'
    },
    BG: () => {
      return getLabel('BG') ?? 'Bulgarie'
    },
    IE: () => {
      return getLabel('IE') ?? 'Irlande'
    },
    IT: () => {
      return getLabel('IT') ?? 'Italie'
    },
    IS: () => {
      return getLabel('IS') ?? 'Islande'
    },
    FI: () => {
      return getLabel('FI') ?? 'Finlande'
    },
    FR: () => {
      return getLabel('FR') ?? 'France'
    },
    LU: () => {
      return getLabel('LU') ?? 'Luxembourg'
    },
    NL: () => {
      return getLabel('NL') ?? 'Pays-Bas'
    },
    PT: () => {
      return getLabel('PT') ?? 'Portugal'
    },
    ES: () => {
      return getLabel('ES') ?? 'Espagne'
    },
    RO: () => {
      return getLabel('RO') ?? 'Roumanie'
    },
    PL: () => {
      return getLabel('PL') ?? 'Pologne'
    },
    LV: () => {
      return getLabel('LV') ?? 'Lettonie'
    },
    CY: () => {
      return getLabel('CY') ?? 'Chypre'
    },
    CZ: () => {
      return getLabel('CZ') ?? 'République tchèque'
    },
    EE: () => {
      return getLabel('EE') ?? 'Estonie'
    },
    GR: () => {
      return getLabel('GR') ?? 'Grèce'
    },
    HR: () => {
      return getLabel('HR') ?? 'Croatie'
    },
    HU: () => {
      return getLabel('HU') ?? 'Hongrie'
    },
    NO: () => {
      return getLabel('NO') ?? 'Norvège'
    },
    LT: () => {
      return getLabel('LT') ?? 'Lituanie'
    },
    MC: () => {
      return getLabel('MC') ?? 'Monaco'
    },
    MT: () => {
      return getLabel('MT') ?? 'Malte'
    },
    SM: () => {
      return getLabel('SM') ?? 'Saint-Marin'
    },
    SI: () => {
      return getLabel('SI') ?? 'Slovénie'
    },
    SK: () => {
      return getLabel('SK') ?? 'Slovaquie'
    },
    CH: () => {
      return getLabel('CH') ?? 'Suisse'
    },
  },
  USD: {
    US: () => {
      return getLabel('US') ?? 'États-Unis'
    },
  },
  GBP: {
    GB: () => {
      return getLabel('GB') ?? 'Royaume-Uni'
    },
    GI: () => {
      return getLabel('GI') ?? 'Gibraltar'
    },
  },
  CAD: {
    CA: () => {
      return getLabel('CA') ?? 'Canada'
    },
  },
  DKK: {
    DK: () => {
      return getLabel('DK') ?? 'Danemark'
    },
  },
  AUD: {
    AU: () => {
      return getLabel('AU') ?? 'Australie'
    },
  },
  SEK: {
    SE: () => {
      return getLabel('SE') ?? 'Suède'
    },
  },
  NOK: {
    NO: () => {
      return getLabel('NO') ?? 'Norvège'
    },
  },
  CHF: {
    CH: () => {
      return getLabel('CH') ?? 'Suisse'
    },
  },
}

export const COUNTRIES: Country[] = [
  {
    label: () => {
      return getLabel('AF') ?? 'Afghanistan'
    },
    code: 'AF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/af.svg',
    prefix: 93,
  },
  {
    label: () => {
      return getLabel('ZA') ?? 'Afrique du Sud'
    },
    code: 'ZA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/za.svg',
    prefix: 27,
  },
  {
    label: () => {
      return getLabel('AL') ?? 'Albanie'
    },
    code: 'AL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/al.svg',
    prefix: 355,
  },
  {
    label: () => {
      return getLabel('DZ') ?? 'Algérie'
    },
    code: 'DZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/dz.svg',
    prefix: 213,
  },
  {
    label: () => {
      return getLabel('DE') ?? 'Allemagne'
    },
    code: 'DE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/de.svg',
    prefix: 49,
  },
  {
    label: () => {
      return getLabel('AD') ?? 'Andorre'
    },
    code: 'AD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ad.svg',
    prefix: 376,
  },
  {
    label: () => {
      return getLabel('AO') ?? 'Angola'
    },
    code: 'AO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ao.svg',
    prefix: 244,
  },
  {
    label: () => {
      return getLabel('AI') ?? 'Anguilla'
    },
    code: 'AI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ai.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('AG') ?? 'Antigua-et-Barbuda'
    },
    code: 'AG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ag.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('SA') ?? 'Arabie Saoudite'
    },
    code: 'SA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sa.svg',
    prefix: 966,
  },
  {
    label: () => {
      return getLabel('AR') ?? 'Argentine'
    },
    code: 'AR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ar.svg',
    prefix: 54,
  },
  {
    label: () => {
      return getLabel('AM') ?? 'Arménie'
    },
    code: 'AM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/am.svg',
    prefix: 374,
  },
  {
    label: () => {
      return getLabel('AW') ?? 'Aruba'
    },
    code: 'AW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/aw.svg',
    prefix: 297,
  },
  {
    label: () => {
      return getLabel('AU') ?? 'Australie'
    },
    code: 'AU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/au.svg',
    prefix: 61,
  },
  {
    label: () => {
      return getLabel('AT') ?? 'Autriche'
    },
    code: 'AT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/at.svg',
    prefix: 43,
  },
  {
    label: () => {
      return getLabel('AZ') ?? 'Azerbaïdjan'
    },
    code: 'AZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/az.svg',
    prefix: 994,
  },
  {
    label: () => {
      return getLabel('BS') ?? 'Bahamas'
    },
    code: 'BS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bs.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('BH') ?? 'Bahreïn'
    },
    code: 'BH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bh.svg',
    prefix: 973,
  },
  {
    label: () => {
      return getLabel('BD') ?? 'Bangladesh'
    },
    code: 'BD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bd.svg',
    prefix: 880,
  },
  {
    label: () => {
      return getLabel('BB') ?? 'Barbade'
    },
    code: 'BB',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bb.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('BE') ?? 'Belgique'
    },
    code: 'BE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/be.svg',
    prefix: 32,
  },
  {
    label: () => {
      return getLabel('BZ') ?? 'Bélize'
    },
    code: 'BZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bz.svg',
    prefix: 501,
  },
  {
    label: () => {
      return getLabel('BJ') ?? 'Bénin'
    },
    code: 'BJ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bj.svg',
    prefix: 229,
  },
  {
    label: () => {
      return getLabel('BM') ?? 'Bermudes'
    },
    code: 'BM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bm.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('BT') ?? 'Bhoutan'
    },
    code: 'BT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bt.svg',
    prefix: 975,
  },
  {
    label: () => {
      return getLabel('BY') ?? 'Biélorussie'
    },
    code: 'BY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/by.svg',
    prefix: 375,
  },
  {
    label: () => {
      return getLabel('MM') ?? 'Birmanie'
    },
    code: 'MM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mm.svg',
    prefix: 95,
  },
  {
    label: () => {
      return getLabel('BO') ?? 'Bolivie'
    },
    code: 'BO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bo.svg',
    prefix: 591,
  },
  {
    label: () => {
      return getLabel('BQ') ?? 'Bonaire, Saint Eustache et Saba'
    },
    code: 'BQ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bq.svg',
    prefix: 599,
  },
  {
    label: () => {
      return getLabel('BA') ?? 'Bosnie-Herzégovine'
    },
    code: 'BA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ba.svg',
    prefix: 387,
  },
  {
    label: () => {
      return getLabel('BW') ?? 'Botswana'
    },
    code: 'BW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bw.svg',
    prefix: 267,
  },
  {
    label: () => {
      return getLabel('BR') ?? 'Brésil'
    },
    code: 'BR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/br.svg',
    prefix: 55,
  },
  {
    label: () => {
      return getLabel('BN') ?? 'Brunei'
    },
    code: 'BN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bn.svg',
    prefix: 673,
  },
  {
    label: () => {
      return getLabel('BG') ?? 'Bulgarie'
    },
    code: 'BG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bg.svg',
    prefix: 359,
  },
  {
    label: () => {
      return getLabel('BF') ?? 'Burkina Faso'
    },
    code: 'BF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bf.svg',
    prefix: 226,
  },
  {
    label: () => {
      return getLabel('BI') ?? 'Burundi'
    },
    code: 'BI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bi.svg',
    prefix: 257,
  },
  {
    label: () => {
      return getLabel('KH') ?? 'Cambodge'
    },
    code: 'KH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kh.svg',
    prefix: 855,
  },
  {
    label: () => {
      return getLabel('CM') ?? 'Cameroun'
    },
    code: 'CM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cm.svg',
    prefix: 237,
  },
  {
    label: () => {
      return getLabel('CA') ?? 'Canada'
    },
    code: 'CA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ca.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('CV') ?? 'Cap-Vert'
    },
    code: 'CV',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cv.svg',
    prefix: 238,
  },
  {
    label: () => {
      return getLabel('CL') ?? 'Chili'
    },
    code: 'CL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cl.svg',
    prefix: 56,
  },
  {
    label: () => {
      return getLabel('CN') ?? 'Chine'
    },
    code: 'CN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cn.svg',
    prefix: 86,
  },
  {
    label: () => {
      return getLabel('CY') ?? 'Chypre'
    },
    code: 'CY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cy.svg',
    prefix: 357,
  },
  {
    label: () => {
      return getLabel('CO') ?? 'Colombie'
    },
    code: 'CO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/co.svg',
    prefix: 57,
  },
  {
    label: () => {
      return getLabel('KM') ?? 'Comores'
    },
    code: 'KM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/km.svg',
    prefix: 269,
  },
  {
    label: () => {
      return getLabel('CG') ?? 'Congo'
    },
    code: 'CG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cg.svg',
    prefix: 242,
  },
  {
    label: () => {
      return getLabel('KP') ?? 'Corée du Nord'
    },
    code: 'KP',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kp.svg',
    prefix: 850,
  },
  {
    label: () => {
      return getLabel('KR') ?? 'Corée du Sud'
    },
    code: 'KR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kr.svg',
    prefix: 82,
  },
  {
    label: () => {
      return getLabel('CR') ?? 'Costa Rica'
    },
    code: 'CR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cr.svg',
    prefix: 506,
  },
  {
    label: () => {
      return getLabel('CI') ?? "Côte d'Ivoire"
    },
    code: 'CI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ci.svg',
    prefix: 225,
  },
  {
    label: () => {
      return getLabel('HR') ?? 'Croatie'
    },
    code: 'HR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/hr.svg',
    prefix: 385,
  },
  {
    label: () => {
      return getLabel('CU') ?? 'Cuba'
    },
    code: 'CU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cu.svg',
    prefix: 53,
  },
  {
    label: () => {
      return getLabel('CW') ?? 'Curaçao'
    },
    code: 'CW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cw.svg',
    prefix: 599,
  },
  {
    label: () => {
      return getLabel('DK') ?? 'Danemark'
    },
    code: 'DK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/dk.svg',
    prefix: 45,
  },
  {
    label: () => {
      return getLabel('DJ') ?? 'Djibouti'
    },
    code: 'DJ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/dj.svg',
    prefix: 253,
  },
  {
    label: () => {
      return getLabel('DM') ?? 'Dominique'
    },
    code: 'DM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/dm.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('EG') ?? 'Égypte'
    },
    code: 'EG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/eg.svg',
    prefix: 20,
  },
  {
    label: () => {
      return getLabel('AE') ?? 'Émirats arabes unis'
    },
    code: 'AE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ae.svg',
    prefix: 971,
  },
  {
    label: () => {
      return getLabel('EC') ?? 'Équateur'
    },
    code: 'EC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ec.svg',
    prefix: 593,
  },
  {
    label: () => {
      return getLabel('ER') ?? 'Érythrée'
    },
    code: 'ER',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/er.svg',
    prefix: 291,
  },
  {
    label: () => {
      return getLabel('ES') ?? 'Espagne'
    },
    code: 'ES',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/es.svg',
    prefix: 34,
  },
  {
    label: () => {
      return getLabel('EE') ?? 'Estonie'
    },
    code: 'EE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ee.svg',
    prefix: 372,
  },
  {
    label: () => {
      return getLabel('SZ') ?? "Eswatini (République d')"
    },
    code: 'SZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sz.svg',
    prefix: 268,
  },
  {
    label: () => {
      return getLabel('US') ?? 'États-Unis'
    },
    code: 'US',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/us.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('ET') ?? 'Éthiopie'
    },
    code: 'ET',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/et.svg',
    prefix: 251,
  },
  {
    label: () => {
      return getLabel('FJ') ?? 'Fidji'
    },
    code: 'FJ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fj.svg',
    prefix: 679,
  },
  {
    label: () => {
      return getLabel('FI') ?? 'Finlande'
    },
    code: 'FI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fi.svg',
    prefix: 358,
  },
  {
    label: () => {
      return getLabel('FR') ?? 'France'
    },
    code: 'FR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fr.svg',
    prefix: 33,
  },
  {
    label: () => {
      return getLabel('GA') ?? 'Gabon'
    },
    code: 'GA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ga.svg',
    prefix: 241,
  },
  {
    label: () => {
      return getLabel('GM') ?? 'Gambie'
    },
    code: 'GM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gm.svg',
    prefix: 220,
  },
  {
    label: () => {
      return getLabel('GE') ?? 'Géorgie'
    },
    code: 'GE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ge.svg',
    prefix: 995,
  },
  {
    label: () => {
      return getLabel('GH') ?? 'Ghana'
    },
    code: 'GH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gh.svg',
    prefix: 233,
  },
  {
    label: () => {
      return getLabel('GI') ?? 'Gibraltar'
    },
    code: 'GI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gi.svg',
    prefix: 350,
  },
  {
    label: () => {
      return getLabel('GR') ?? 'Grèce'
    },
    code: 'GR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gr.svg',
    prefix: 30,
  },
  {
    label: () => {
      return getLabel('GD') ?? 'Grenade'
    },
    code: 'GD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gd.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('GL') ?? 'Groenland'
    },
    code: 'GL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gl.svg',
    prefix: 299,
  },
  {
    label: () => {
      return getLabel('GP') ?? 'Guadeloupe'
    },
    code: 'GP',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gp.svg',
    prefix: 590,
  },
  {
    label: () => {
      return getLabel('GU') ?? 'Guam'
    },
    code: 'GU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gu.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('GT') ?? 'Guatémala'
    },
    code: 'GT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gt.svg',
    prefix: 502,
  },
  {
    label: () => {
      return getLabel('GG') ?? 'Guernesey'
    },
    code: 'GG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gg.svg',
    prefix: 44,
  },
  {
    label: () => {
      return getLabel('GN') ?? 'Guinée'
    },
    code: 'GN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gn.svg',
    prefix: 224,
  },
  {
    label: () => {
      return getLabel('GQ') ?? 'Guinée équatoriale'
    },
    code: 'GQ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gq.svg',
    prefix: 240,
  },
  {
    label: () => {
      return getLabel('GW') ?? 'Guinée-Bissau'
    },
    code: 'GW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gw.svg',
    prefix: 245,
  },
  {
    label: () => {
      return getLabel('GY') ?? 'Guyane'
    },
    code: 'GY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gy.svg',
    prefix: 592,
  },
  {
    label: () => {
      return getLabel('GF') ?? 'Guyane française'
    },
    code: 'GF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gf.svg',
    prefix: 594,
  },
  {
    label: () => {
      return getLabel('HT') ?? 'Haïti'
    },
    code: 'HT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ht.svg',
    prefix: 509,
  },
  {
    label: () => {
      return getLabel('HN') ?? 'Honduras'
    },
    code: 'HN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/hn.svg',
    prefix: 504,
  },
  {
    label: () => {
      return getLabel('HK') ?? 'Hong Kong'
    },
    code: 'HK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/hk.svg',
    prefix: 852,
  },
  {
    label: () => {
      return getLabel('HU') ?? 'Hongrie'
    },
    code: 'HU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/hu.svg',
    prefix: 36,
  },
  {
    label: () => {
      return getLabel('CX') ?? 'Île Christmas'
    },
    code: 'CX',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cx.svg',
    prefix: 61,
  },
  {
    label: () => {
      return getLabel('SJ') ?? 'Île Jan Mayen'
    },
    code: 'SJ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sj.svg',
    prefix: 47,
  },
  {
    label: () => {
      return getLabel('NF') ?? 'Île Norfolk'
    },
    code: 'NF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nf.svg',
    prefix: 672,
  },
  {
    label: () => {
      return getLabel('IM') ?? 'Île de Man'
    },
    code: 'IM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/im.svg',
    prefix: 44,
  },
  {
    label: () => {
      return getLabel('AX') ?? 'Îles Åland'
    },
    code: 'AX',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ax.svg',
    prefix: 358,
  },
  {
    label: () => {
      return getLabel('KY') ?? 'Îles Caïmans'
    },
    code: 'KY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ky.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('CC') ?? 'Îles Cocos'
    },
    code: 'CC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cc.svg',
    prefix: 61,
  },
  {
    label: () => {
      return getLabel('CK') ?? 'Îles Cook'
    },
    code: 'CK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ck.svg',
    prefix: 682,
  },
  {
    label: () => {
      return getLabel('FO') ?? 'Îles Féroé'
    },
    code: 'FO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fo.svg',
    prefix: 298,
  },
  {
    label: () => {
      return getLabel('FK') ?? 'Îles Malouines'
    },
    code: 'FK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fk.svg',
    prefix: 500,
  },
  {
    label: () => {
      return getLabel('MP') ?? 'Îles Mariannes du Nord'
    },
    code: 'MP',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mp.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('MH') ?? 'Îles Marshal'
    },
    code: 'MH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mh.svg',
    prefix: 692,
  },
  {
    label: () => {
      return getLabel('TC') ?? 'Îles Turques-et-Caïques'
    },
    code: 'TC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tc.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('VG') ?? 'Îles Vierges britanniques'
    },
    code: 'VG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vg.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('VI') ?? 'Îles Vierges des États-Unis'
    },
    code: 'VI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vi.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('IN') ?? 'Inde'
    },
    code: 'IN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/in.svg',
    prefix: 91,
  },
  {
    label: () => {
      return getLabel('ID') ?? 'Indonésie'
    },
    code: 'ID',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/id.svg',
    prefix: 62,
  },
  {
    label: () => {
      return getLabel('IQ') ?? 'Irak'
    },
    code: 'IQ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/iq.svg',
    prefix: 964,
  },
  {
    label: () => {
      return getLabel('IR') ?? 'Iran'
    },
    code: 'IR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ir.svg',
    prefix: 98,
  },
  {
    label: () => {
      return getLabel('IE') ?? 'Irlande'
    },
    code: 'IE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ie.svg',
    prefix: 353,
  },
  {
    label: () => {
      return getLabel('IS') ?? 'Islande'
    },
    code: 'IS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/is.svg',
    prefix: 354,
  },
  {
    label: () => {
      return getLabel('IL') ?? 'Israël'
    },
    code: 'IL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/il.svg',
    prefix: 972,
  },
  {
    label: () => {
      return getLabel('IT') ?? 'Italie'
    },
    code: 'IT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/it.svg',
    prefix: 39,
  },
  {
    label: () => {
      return getLabel('JM') ?? 'Jamaïque'
    },
    code: 'JM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/jm.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('JP') ?? 'Japon'
    },
    code: 'JP',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/jp.svg',
    prefix: 81,
  },
  {
    label: () => {
      return getLabel('JE') ?? 'Jersey'
    },
    code: 'JE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/je.svg',
    prefix: 44,
  },
  {
    label: () => {
      return getLabel('JO') ?? 'Jordanie'
    },
    code: 'JO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/jo.svg',
    prefix: 962,
  },
  {
    label: () => {
      return getLabel('KZ') ?? 'Kazakhstan'
    },
    code: 'KZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kz.svg',
    prefix: 7,
  },
  {
    label: () => {
      return getLabel('KE') ?? 'Kenya'
    },
    code: 'KE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ke.svg',
    prefix: 254,
  },
  {
    label: () => {
      return getLabel('KG') ?? 'Kirghizistan'
    },
    code: 'KG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kg.svg',
    prefix: 996,
  },
  {
    label: () => {
      return getLabel('KI') ?? 'Kiribati'
    },
    code: 'KI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ki.svg',
    prefix: 686,
  },
  {
    label: () => {
      return getLabel('KW') ?? 'Koweït'
    },
    code: 'KW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kw.svg',
    prefix: 965,
  },
  {
    label: () => {
      return getLabel('LA') ?? 'Laos'
    },
    code: 'LA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/la.svg',
    prefix: 856,
  },
  {
    label: () => {
      return getLabel('LS') ?? 'Lesotho'
    },
    code: 'LS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ls.svg',
    prefix: 266,
  },
  {
    label: () => {
      return getLabel('LV') ?? 'Lettonie'
    },
    code: 'LV',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lv.svg',
    prefix: 371,
  },
  {
    label: () => {
      return getLabel('LB') ?? 'Liban'
    },
    code: 'LB',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lb.svg',
    prefix: 961,
  },
  {
    label: () => {
      return getLabel('LR') ?? 'Libéria'
    },
    code: 'LR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lr.svg',
    prefix: 231,
  },
  {
    label: () => {
      return getLabel('LY') ?? 'Libye'
    },
    code: 'LY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ly.svg',
    prefix: 218,
  },
  {
    label: () => {
      return getLabel('LI') ?? 'Liechtenstein'
    },
    code: 'LI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/li.svg',
    prefix: 423,
  },
  {
    label: () => {
      return getLabel('LT') ?? 'Lituanie'
    },
    code: 'LT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lt.svg',
    prefix: 370,
  },
  {
    label: () => {
      return getLabel('LU') ?? 'Luxembourg'
    },
    code: 'LU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lu.svg',
    prefix: 352,
  },
  {
    label: () => {
      return getLabel('MO') ?? 'Macao'
    },
    code: 'MO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mo.svg',
    prefix: 853,
  },
  {
    label: () => {
      return getLabel('MG') ?? 'Madagascar'
    },
    code: 'MG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mg.svg',
    prefix: 261,
  },
  {
    label: () => {
      return getLabel('MY') ?? 'Malaisie'
    },
    code: 'MY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/my.svg',
    prefix: 60,
  },
  {
    label: () => {
      return getLabel('MW') ?? 'Malawi'
    },
    code: 'MW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mw.svg',
    prefix: 265,
  },
  {
    label: () => {
      return getLabel('MV') ?? 'Maldives'
    },
    code: 'MV',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mv.svg',
    prefix: 960,
  },
  {
    label: () => {
      return getLabel('ML') ?? 'Mali'
    },
    code: 'ML',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ml.svg',
    prefix: 223,
  },
  {
    label: () => {
      return getLabel('MT') ?? 'Malte'
    },
    code: 'MT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mt.svg',
    prefix: 356,
  },
  {
    label: () => {
      return getLabel('MA') ?? 'Maroc'
    },
    code: 'MA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ma.svg',
    prefix: 212,
  },
  {
    label: () => {
      return getLabel('MQ') ?? 'Martinique'
    },
    code: 'MQ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mq.svg',
    prefix: 596,
  },
  {
    label: () => {
      return getLabel('MU') ?? 'Maurice'
    },
    code: 'MU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mu.svg',
    prefix: 230,
  },
  {
    label: () => {
      return getLabel('MR') ?? 'Mauritanie'
    },
    code: 'MR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mr.svg',
    prefix: 222,
  },
  {
    label: () => {
      return getLabel('YT') ?? 'Mayotte'
    },
    code: 'YT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/yt.svg',
    prefix: 262,
  },
  {
    label: () => {
      return getLabel('MX') ?? 'Mexique'
    },
    code: 'MX',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mx.svg',
    prefix: 52,
  },
  {
    label: () => {
      return getLabel('FM') ?? 'Micronésie (États Fédérés de)'
    },
    code: 'FM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/fm.svg',
    prefix: 691,
  },
  {
    label: () => {
      return getLabel('MD') ?? 'Moldavie'
    },
    code: 'MD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/md.svg',
    prefix: 373,
  },
  {
    label: () => {
      return getLabel('MC') ?? 'Monaco'
    },
    code: 'MC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mc.svg',
    prefix: 377,
  },
  {
    label: () => {
      return getLabel('MN') ?? 'Mongolie'
    },
    code: 'MN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mn.svg',
    prefix: 976,
  },
  {
    label: () => {
      return getLabel('ME') ?? 'Monténégro'
    },
    code: 'ME',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/me.svg',
    prefix: 382,
  },
  {
    label: () => {
      return getLabel('MS') ?? 'Montserrat'
    },
    code: 'MS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ms.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('MZ') ?? 'Mozambique'
    },
    code: 'MZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mz.svg',
    prefix: 258,
  },
  {
    label: () => {
      return getLabel('NA') ?? 'Namibie'
    },
    code: 'NA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/na.svg',
    prefix: 264,
  },
  {
    label: () => {
      return getLabel('NR') ?? 'Nauru'
    },
    code: 'NR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nr.svg',
    prefix: 674,
  },
  {
    label: () => {
      return getLabel('NP') ?? 'Népal'
    },
    code: 'NP',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/np.svg',
    prefix: 977,
  },
  {
    label: () => {
      return getLabel('NI') ?? 'Nicaragua'
    },
    code: 'NI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ni.svg',
    prefix: 505,
  },
  {
    label: () => {
      return getLabel('NE') ?? 'Niger'
    },
    code: 'NE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ne.svg',
    prefix: 227,
  },
  {
    label: () => {
      return getLabel('NG') ?? 'Nigeria'
    },
    code: 'NG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ng.svg',
    prefix: 234,
  },
  {
    label: () => {
      return getLabel('NU') ?? 'Niue'
    },
    code: 'NU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nu.svg',
    prefix: 683,
  },
  {
    label: () => {
      return getLabel('NO') ?? 'Norvège'
    },
    code: 'NO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/no.svg',
    prefix: 47,
  },
  {
    label: () => {
      return getLabel('NC') ?? 'Nouvelle-Calédonie'
    },
    code: 'NC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nc.svg',
    prefix: 687,
  },
  {
    label: () => {
      return getLabel('NZ') ?? 'Nouvelle-Zélande'
    },
    code: 'NZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nz.svg',
    prefix: 64,
  },
  {
    label: () => {
      return getLabel('OM') ?? 'Oman'
    },
    code: 'OM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/om.svg',
    prefix: 968,
  },
  {
    label: () => {
      return getLabel('UG') ?? 'Ouganda'
    },
    code: 'UG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ug.svg',
    prefix: 256,
  },
  {
    label: () => {
      return getLabel('UZ') ?? 'Ouzbékistan'
    },
    code: 'UZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/uz.svg',
    prefix: 998,
  },
  {
    label: () => {
      return getLabel('PK') ?? 'Pakistan'
    },
    code: 'PK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pk.svg',
    prefix: 92,
  },
  {
    label: () => {
      return getLabel('PW') ?? 'Palaos'
    },
    code: 'PW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pw.svg',
    prefix: 680,
  },
  {
    label: () => {
      return getLabel('PS') ?? 'Palestine, État de'
    },
    code: 'PS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ps.svg',
    prefix: 970,
  },
  {
    label: () => {
      return getLabel('PA') ?? 'Panama'
    },
    code: 'PA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pa.svg',
    prefix: 507,
  },
  {
    label: () => {
      return getLabel('PG') ?? 'Papouasie-Nouvelle-Guinée'
    },
    code: 'PG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pg.svg',
    prefix: 675,
  },
  {
    label: () => {
      return getLabel('PY') ?? 'Paraguay'
    },
    code: 'PY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/py.svg',
    prefix: 595,
  },
  {
    label: () => {
      return getLabel('NL') ?? 'Pays-Bas'
    },
    code: 'NL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/nl.svg',
    prefix: 31,
  },
  {
    label: () => {
      return getLabel('PE') ?? 'Pérou'
    },
    code: 'PE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pe.svg',
    prefix: 51,
  },
  {
    label: () => {
      return getLabel('PH') ?? 'Philippines'
    },
    code: 'PH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ph.svg',
    prefix: 63,
  },
  {
    label: () => {
      return getLabel('PL') ?? 'Pologne'
    },
    code: 'PL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pl.svg',
    prefix: 48,
  },
  {
    label: () => {
      return getLabel('PF') ?? 'Polynésie française'
    },
    code: 'PF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pf.svg',
    prefix: 689,
  },
  {
    label: () => {
      return getLabel('PR') ?? 'Porto Rico'
    },
    code: 'PR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pr.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('PT') ?? 'Portugal'
    },
    code: 'PT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pt.svg',
    prefix: 351,
  },
  {
    label: () => {
      return getLabel('QA') ?? 'Qatar'
    },
    code: 'QA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/qa.svg',
    prefix: 974,
  },
  {
    label: () => {
      return getLabel('CF') ?? 'République centrafricaine'
    },
    code: 'CF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cf.svg',
    prefix: 236,
  },
  {
    label: () => {
      return getLabel('MK') ?? 'République de Macédoine du Nord'
    },
    code: 'MK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mk.svg',
    prefix: 389,
  },
  {
    label: () => {
      return getLabel('CD') ?? 'République démocratique du Congo'
    },
    code: 'CD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cd.svg',
    prefix: 243,
  },
  {
    label: () => {
      return getLabel('DO') ?? 'République dominicaine'
    },
    code: 'DO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/do.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('CZ') ?? 'République tchèque'
    },
    code: 'CZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/cz.svg',
    prefix: 420,
  },
  {
    label: () => {
      return getLabel('RE') ?? 'Réunion, La'
    },
    code: 'RE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/re.svg',
    prefix: 262,
  },
  {
    label: () => {
      return getLabel('RO') ?? 'Roumanie'
    },
    code: 'RO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ro.svg',
    prefix: 40,
  },
  {
    label: () => {
      return getLabel('GB') ?? 'Royaume-Uni'
    },
    code: 'GB',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gb.svg',
    prefix: 44,
  },
  {
    label: () => {
      return getLabel('RU') ?? 'Russie'
    },
    code: 'RU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ru.svg',
    prefix: 7,
  },
  {
    label: () => {
      return getLabel('RW') ?? 'Rwanda'
    },
    code: 'RW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/rw.svg',
    prefix: 250,
  },
  {
    label: () => {
      return getLabel('EH') ?? 'Sahara occidental'
    },
    code: 'EH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/eh.svg',
    prefix: 212,
  },
  {
    label: () => {
      return getLabel('BL') ?? 'Saint Barthélemy'
    },
    code: 'BL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/bl.svg',
    prefix: 590,
  },
  {
    label: () => {
      return getLabel('KN') ?? 'Saint-Christophe-et-Niévès'
    },
    code: 'KN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/kn.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('SM') ?? 'Saint-Marin'
    },
    code: 'SM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sm.svg',
    prefix: 378,
  },
  {
    label: () => {
      return getLabel('MF') ?? 'Saint-Martin (Antilles françaises)'
    },
    code: 'MF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/mf.svg',
    prefix: 590,
  },
  {
    label: () => {
      return getLabel('SX') ?? 'Saint-Martin (Royaume des Pays-Bas)'
    },
    code: 'SX',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sx.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('PM') ?? 'Saint-Pierre-et-Miquelon'
    },
    code: 'PM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/pm.svg',
    prefix: 508,
  },
  {
    label: () => {
      return getLabel('VA') ?? 'Saint-Siège'
    },
    code: 'VA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/va.svg',
    prefix: 39,
  },
  {
    label: () => {
      return getLabel('VC') ?? 'Saint-Vincent-et-les-Grenadines'
    },
    code: 'VC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vc.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('SH') ?? 'Sainte-Hélène, Ascension et Tristan da Cunha'
    },
    code: 'SH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sh.svg',
    prefix: 290,
  },
  {
    label: () => {
      return getLabel('LC') ?? 'Sainte-Lucie'
    },
    code: 'LC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lc.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('SB') ?? 'Salomon'
    },
    code: 'SB',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sb.svg',
    prefix: 677,
  },
  {
    label: () => {
      return getLabel('SV') ?? 'Salvador'
    },
    code: 'SV',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sv.svg',
    prefix: 503,
  },
  {
    label: () => {
      return getLabel('WS') ?? 'Samoa'
    },
    code: 'WS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ws.svg',
    prefix: 685,
  },
  {
    label: () => {
      return getLabel('AS') ?? 'Samoa américaines'
    },
    code: 'AS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/as.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('ST') ?? 'Sao Tomé-et-Principe'
    },
    code: 'ST',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/st.svg',
    prefix: 239,
  },
  {
    label: () => {
      return getLabel('SN') ?? 'Sénégal'
    },
    code: 'SN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sn.svg',
    prefix: 221,
  },
  {
    label: () => {
      return getLabel('RS') ?? 'Serbie'
    },
    code: 'RS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/rs.svg',
    prefix: 381,
  },
  {
    label: () => {
      return getLabel('SC') ?? 'Seychelles'
    },
    code: 'SC',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sc.svg',
    prefix: 248,
  },
  {
    label: () => {
      return getLabel('SL') ?? 'Sierra Leone'
    },
    code: 'SL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sl.svg',
    prefix: 232,
  },
  {
    label: () => {
      return getLabel('SG') ?? 'Singapour'
    },
    code: 'SG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sg.svg',
    prefix: 65,
  },
  {
    label: () => {
      return getLabel('SK') ?? 'Slovaquie'
    },
    code: 'SK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sk.svg',
    prefix: 421,
  },
  {
    label: () => {
      return getLabel('SI') ?? 'Slovénie'
    },
    code: 'SI',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/si.svg',
    prefix: 386,
  },
  {
    label: () => {
      return getLabel('SO') ?? 'Somalie'
    },
    code: 'SO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/so.svg',
    prefix: 252,
  },
  {
    label: () => {
      return getLabel('SD') ?? 'Soudan'
    },
    code: 'SD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sd.svg',
    prefix: 249,
  },
  {
    label: () => {
      return getLabel('SS') ?? 'Soudan du Sud'
    },
    code: 'SS',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ss.svg',
    prefix: 211,
  },
  {
    label: () => {
      return getLabel('LK') ?? 'Sri Lanka'
    },
    code: 'LK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/lk.svg',
    prefix: 94,
  },
  {
    label: () => {
      return getLabel('SE') ?? 'Suède'
    },
    code: 'SE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/se.svg',
    prefix: 46,
  },
  {
    label: () => {
      return getLabel('CH') ?? 'Suisse'
    },
    code: 'CH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ch.svg',
    prefix: 41,
  },
  {
    label: () => {
      return getLabel('SR') ?? 'Suriname'
    },
    code: 'SR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sr.svg',
    prefix: 597,
  },
  {
    label: () => {
      return getLabel('SY') ?? 'Syrie'
    },
    code: 'SY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/sy.svg',
    prefix: 963,
  },
  {
    label: () => {
      return getLabel('TJ') ?? 'Tadjikistan'
    },
    code: 'TJ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tj.svg',
    prefix: 992,
  },
  {
    label: () => {
      return getLabel('TW') ?? 'Taiwan'
    },
    code: 'TW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tw.svg',
    prefix: 886,
  },
  {
    label: () => {
      return getLabel('TZ') ?? 'Tanzanie'
    },
    code: 'TZ',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tz.svg',
    prefix: 255,
  },
  {
    label: () => {
      return getLabel('TD') ?? 'Tchad'
    },
    code: 'TD',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/td.svg',
    prefix: 235,
  },
  {
    label: () => {
      return getLabel('IO') ?? "Territoire britannique de l'océan Indien"
    },
    code: 'IO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/io.svg',
    prefix: 246,
  },
  {
    label: () => {
      return getLabel('TH') ?? 'Thaïlande'
    },
    code: 'TH',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/th.svg',
    prefix: 66,
  },
  {
    label: () => {
      return getLabel('TL') ?? 'Timor Oriental'
    },
    code: 'TL',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tl.svg',
    prefix: 670,
  },
  {
    label: () => {
      return getLabel('TG') ?? 'Togo'
    },
    code: 'TG',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tg.svg',
    prefix: 228,
  },
  {
    label: () => {
      return getLabel('TK') ?? 'Tokelau'
    },
    code: 'TK',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tk.svg',
    prefix: 690,
  },
  {
    label: () => {
      return getLabel('TO') ?? 'Tonga'
    },
    code: 'TO',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/to.svg',
    prefix: 676,
  },
  {
    label: () => {
      return getLabel('TT') ?? 'Trinidad et Tobago'
    },
    code: 'TT',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tt.svg',
    prefix: 1,
  },
  {
    label: () => {
      return getLabel('TN') ?? 'Tunisie'
    },
    code: 'TN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tn.svg',
    prefix: 216,
  },
  {
    label: () => {
      return getLabel('TM') ?? 'Turkménistan'
    },
    code: 'TM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tm.svg',
    prefix: 993,
  },
  {
    label: () => {
      return getLabel('TR') ?? 'Turquie'
    },
    code: 'TR',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tr.svg',
    prefix: 90,
  },
  {
    label: () => {
      return getLabel('TV') ?? 'Tuvalu'
    },
    code: 'TV',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/tv.svg',
    prefix: 688,
  },
  {
    label: () => {
      return getLabel('UA') ?? 'Ukraine'
    },
    code: 'UA',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ua.svg',
    prefix: 380,
  },
  {
    label: () => {
      return getLabel('UY') ?? 'Uruguay'
    },
    code: 'UY',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/uy.svg',
    prefix: 598,
  },
  {
    label: () => {
      return getLabel('VU') ?? 'Vanuatu'
    },
    code: 'VU',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vu.svg',
    prefix: 678,
  },
  {
    label: () => {
      return getLabel('VE') ?? 'Venezuela'
    },
    code: 'VE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ve.svg',
    prefix: 58,
  },
  {
    label: () => {
      return getLabel('VN') ?? 'Viêt Nam'
    },
    code: 'VN',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vn.svg',
    prefix: 84,
  },
  {
    label: () => {
      return getLabel('WF') ?? 'Wallis et Futuna'
    },
    code: 'WF',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/wf.svg',
    prefix: 681,
  },
  {
    label: () => {
      return getLabel('YE') ?? 'Yémen'
    },
    code: 'YE',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/ye.svg',
    prefix: 967,
  },
  {
    label: () => {
      return getLabel('ZM') ?? 'Zambie'
    },
    code: 'ZM',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/zm.svg',
    prefix: 260,
  },
  {
    label: () => {
      return getLabel('ZW') ?? 'Zimbabwe'
    },
    code: 'ZW',
    flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/zw.svg',
    prefix: 263,
  },
]
